<template>
  <div class="admin-counsel">

    <adminCounsel_picker
      v-if="adminCounsel_picker_show"
      :oth_showPicker="showPicker"
      :setList="setCounselList"
      :counselList="counselList"
      @submit="onSetSubmit"
    />


    <!-- 다이얼로그 -->
    <div class="dialog" v-if="usingDialog">
      <span class="cls" @click="usingDialog = null"></span>

      <!-- 상담 수정/추가 -->
      <div class="paper" v-if="usingDialog === 'counsel'">
        <div class="header">
          <h2>{{ editCounsel.idx ? '상담 수정' : '상담 추가' }}</h2>
        </div>
        <div class="form">
          <label for="counsel-cover">썸네일
            <img :src="editCounsel.cover" />
            <input type="file" id="counsel-cover" hidden @change="counselOnFileChange" />
          </label>
          <label for="counsel-title">제목
            <input type="text" id="counsel-title" v-model="editCounsel.title" placeholder="제목" />
          </label>
          <label for="counsel-description">설명
            <textarea id="counsel-description" v-model="editCounsel.description" placeholder="설명"></textarea>
          </label>
          <label>유형
            <select v-model="editCounsel.category">
              <option v-for="cat in categoryList" :key="cat.value" :value="cat.value">{{ cat.name }}</option>
            </select>
          </label>
        </div>
        <div class="btns">
          <button v-if="editCounsel.idx" class="del" @click="deleteCounsel">삭제</button>
          <button class="save" @click="saveCounsel">저장</button>
        </div>
      </div>

      <!-- 페이지 수정/추가 -->
      <div class="paper" v-if="usingDialog === 'page'">
        <div class="header">
          <h2>{{ editPage.idx ? '슬라이드 수정' : '슬라이드 추가' }}</h2>
        </div>
        <div class="form">
          <label>이미지
            <img :src="editPage.image" />
            <input type="file" id="page-image" hidden @change="pageOnFileChange" />
          </label>
          <label>내용
            <textarea type="text" v-model="editPage.content" placeholder="내용"></textarea>
          </label>
          <label>힌트
            <textarea type="text" v-model="editPage.memo" placeholder="힌트"></textarea>
          </label>
          <label>순서
            <input type="number" v-model="editPage.page_no" placeholder="순서" />
          </label>
          <label>Q. 질문
            <input type="text" v-model="editPage.question" placeholder="퀴즈 질문" />
          </label>
          <div class="options">
            <label v-for="item in editPage_options" :key ="item.idx" > A. <input type="text" v-model="item.option_text" /> </label>
            <button @click="addOptionsAtPage"> 추가하기 </button>
          </div>
        </div>
        <div class="btns">
          <button v-if="editPage.idx" class="del" @click="deletePage">삭제</button>
          <button class="save" @click="savePage">저장</button>
        </div>
      </div>

      
      <!-- 세트 구성 보기 -->
      <div class="paper" v-if="usingDialog === 'set' && selectedSet">
        <div class="header">
          <h2>세트 보기</h2>
        </div>

        <div class="profile-lg">
          <label for="set-cover">
            <input type="file" id="set-cover" hidden @change="setOnFileChange" />
            <img :src="selectedSet.cover" />
          </label>
          <div>
            <input type="text" v-model="selectedSet.title" placeholder="세트 제목" />
            <textarea v-model="selectedSet.description" placeholder="세트 설명"></textarea>
          </div>
        </div>
        <ul class="list-t">
          <li v-for="Counsel in setCounselList" :key="Counsel.idx">
            <img :src="Counsel.cover" />
            <div class="description">
              <h2>{{ getCategory(Counsel.category).name }}</h2>
              <span>{{ Counsel.title }}</span>
            </div>
          </li>
          <li @click="showPicker(true)" class="add"><i class="ph ph-plus-square"></i>눌러서 RP 추가</li>
        </ul>
        <div class="btns">
          <button v-if="selectedSet.idx" class="del" @click="deleteCounselSet(selectedSet)">삭제</button>
          <button class="save" @click="saveSetInfo">저장</button>
        </div>
        
      </div>

    </div>





    <!-- 헤더 -->
    <div class="header">
      <h2>상담 관리</h2>
    </div>

    <div class="chapter">
      <span :class="{ sel: selChapter === 'set' }" @click="selChapter = 'set'">완성된 상담</span>
      <span :class="{ sel: selChapter === 'single' }" @click="selChapter = 'single'">파츠별 상담</span>
    </div>

    <div class="content" v-if="selChapter == 'set'">
      <!-- 세트 목록 -->
      <div class="left">
        <div class="header"> <p>목록</p> <button @click="newSet">+ 세트 추가</button> </div>
        <ul v-if="setList.length > 0">
          <li v-for="item in setList" :key="item.idx" :class="{ active: selectedSet && selectedSet.idx === item.idx }">
            <img :src="item.cover" @click="selectSet(item)" />
            <div class="description" @click="selectSet(item)">
              <h2>{{ item.title }}</h2>
              <span>{{ item.description }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="content" v-if="selChapter == 'single'">
      <!-- 상담 목록 -->
      <div class="left">
        <div class="header"> <p>목록</p> <button @click="newCounsel">+ 상담 추가</button> </div>
        <ul v-if="counselList.length > 0">
          <li v-for="item in counselList" :key="item.idx" :class="{ active: selectedCounsel && selectedCounsel.idx === item.idx }">
            <img :src="item.cover" @click="selectCounsel(item)" />
            <div class="description" @click="selectCounsel(item)">
              <h2>{{ item.title }}</h2>
              <span>{{ item.description }}</span>
              <span>{{ getCategory(item.category).name }}</span>
            </div>
            <button @click="editCounsel = { ...item }; usingDialog = 'counsel'">수정</button>
          </li>
        </ul>
      </div>

      <!-- 페이지 목록 -->
      <div class="right" v-if="selectedCounsel">
        <div class="header">
          <h3>페이지</h3>
          <button @click="newPage">+ 페이지 추가</button>
        </div>
        <ul>
          <li v-for="page in pageList" :key="page.idx"
              @click="selectEditPage(page)">
            <img :src="page.image" />
            <span>{{ page.content }}</span>
          </li>
        </ul>
      </div>
      
    </div>
  </div>
</template>


<script>
import { inject, ref, onMounted } from "vue";
import adminCounsel_picker from "./adminCounsel_picker.vue";

export default {
  name: "adminCounsel",
  components: { adminCounsel_picker },
  setup() {
    const sql_query = inject("sql_query");
    const getMbid = inject("getMbid");

    const selChapter = ref("set");

    const adminCounsel_picker_show = ref(false);
    const setList = ref([]);
    const counselList = ref([]);
    const setCounselList = ref([]);
    const pageList = ref([]);
    const selectedCounsel = ref(null);
    const selectedSet = ref(null);

    const editSet = ref({ cover: "", title: "", description: "" });
    const editCounsel = ref({ cover: "", title: "", description: "" });
    const editPage = ref({ image: "", content: "", memo: "", page_no: 0, page_type: "content" });
    const editPage_options = ref(null);
    const usingDialog = ref(null);

    function selectEditPage(page) {
      usingDialog.value = 'page';
      editPage.value = { ...page };
      fetchPageOptions();
    }

    async function fetchPageOptions() {
      if (editPage.value) {
        let res = await sql_query(`SELECT * FROM insu_counsel_page_option WHERE page_idx = ${editPage.value.idx} order by option_no asc `);
        editPage_options.value = res;
      }
    }

    const categoryList = [
      {name:"자기소개", value:"self_intro"},
      {name:"아이스브레이킹", value:"ice_break"},
      {name:"니즈환기", value:"needs_awake"},
      {name:"실제예시", value:"real_example"},
      {name:"해결제안", value:"solution_proposal"},
      {name:"거절반격", value:"rejection_counter"},
      {name:"클로징", value:"closing"},
      {name:"사후관리", value:"aftercare"},
      {name:"기타", value:"etc"},
    ];

    function getCategory(value) {
      const category = categoryList.find(cat => cat.value === value);
      return category ? category : {name:"알수없음", value:"unknown"};
    }

    // ---------------------- 상담 CRUD ----------------------
    async function fetchCounselList() {
      const res = await sql_query("SELECT * FROM insu_counsel ORDER BY created_at DESC");
      counselList.value = res;
    }

    async function loadCounselSet(jsonList) {
      try {
        // 1) JSON → Array
        const arr = Array.isArray(jsonList) ? jsonList : JSON.parse(jsonList);

        // 2) order 순서대로 정렬 후 counsel_idx만 추출
        const ordered = arr
          .slice()
          .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

        const ids = ordered
          .map(v => Number(v.counsel_idx))
          .filter(n => Number.isFinite(n));

        if (ids.length === 0) {
          setCounselList.value = [];
          return;
        }

        // 중복 제거(있다면)
        const uniqIds = [...new Set(ids)];

        // 3) SQL SELECT (주문 순서 유지: FIELD)
        const inList = uniqIds.join(',');
        const orderField = ids.join(','); // order 정렬 그대로

        const sql = `
          SELECT *
          FROM insu_counsel
          WHERE idx IN (${inList})
          ORDER BY FIELD(idx, ${orderField})
        `;

        const res = await sql_query(sql);
        setCounselList.value = res;
      } catch (e) {
        console.error('loadCounselSet 실패:', e);
        setCounselList.value = [];
      }
    }


    function newSet() {
      // insert after reload
      sql_query(`
        INSERT INTO insu_counsel_set (title, description, cover, counsel_list)
        VALUES ('새 세트', '', '', '[]')
      `).then(() => {
        fetchSetList();
      });
    }

    function newCounsel() {
      editCounsel.value = { cover: "", title: "", description: "" };
      usingDialog.value = "counsel";
    }

    async function saveCounsel() {
      if (editCounsel.value.idx) {
        await sql_query(`
          UPDATE insu_counsel
          SET title='${editCounsel.value.title}',
              cover='${editCounsel.value.cover}',
              description='${editCounsel.value.description}',
              category='${editCounsel.value.category}'
          WHERE idx=${editCounsel.value.idx}
        `);
      } else {
        await sql_query(`
          INSERT INTO insu_counsel (title, cover, description)
          VALUES ('${editCounsel.value.title}', '${editCounsel.value.cover}', '${editCounsel.value.description}')
        `);
      }
      usingDialog.value = null;
      fetchCounselList();
    }

    async function deleteCounsel() {
      if (!editCounsel.value.idx) return;
      let ask = confirm("정말 삭제하시겠습니까? 이 상담에 속한 페이지들도 모두 삭제됩니다.");
      if (!ask) return;
      await sql_query(`DELETE FROM insu_counsel WHERE idx=${editCounsel.value.idx}`);
      usingDialog.value = null;
      fetchCounselList();
      pageList.value = [];
      selectedCounsel.value = null;
    }

    async function deleteCounselSet(counselSet) {
      console.log(counselSet);
      if (!counselSet.idx) return;
      let ask = confirm("정말 삭제하시겠습니까? 이 상담에 속한 페이지들도 모두 삭제됩니다.");
      if (!ask) return;
      await sql_query(`DELETE FROM insu_counsel_set WHERE idx=${counselSet.idx}`);
      usingDialog.value = null;
      selectedCounsel.value = null;
      pageList.value = [];
      fetchSetList();
    }

    async function counselOnFileChange(e) {
      const input = e.target;
      const file = input.files ? input.files[0] : null;
      if (!file) return;

      // 1) 로컬 미리보기
      editCounsel.value.cover = URL.createObjectURL(file);

      // 2) 서버 업로드
      const formData = new FormData();
      formData.append('idx', editCounsel.value.idx || '');
      formData.append('table', 'insu_counsel');
      formData.append('usage', 'cover_img');
      formData.append('user', getMbid());
      formData.append('file', file);

    try {
      const response = await fetch('/api/upload/image', {
        method: 'POST',
        body: formData,
        mode: 'cors',
        credentials: 'include'
      });

      const data = await response.json();
      console.log(data);

      if (data.url) {
        editCounsel.value.cover = data.url;
        // DB 업데이트 (수정 모드일 경우)
          if (editCounsel.value.idx) {
            await sql_query(`
              UPDATE insu_counsel
              SET cover='${data.url}'
              WHERE idx=${editCounsel.value.idx}
            `);
          }
        } else {
          alert("이미지 업로드 실패");
        }
      } catch (err) {
        console.error('업로드 중 오류:', err);
        alert("업로드 중 오류 발생");
      }
    }


    async function pageOnFileChange(e) {
      const input = e.target;
      const file = input.files ? input.files[0] : null;
      if (!file) return;

      // 1) 로컬 미리보기
      editCounsel.value.cover = URL.createObjectURL(file);

      // 2) 서버 업로드
      const formData = new FormData();
      formData.append('idx', editPage.value.idx || '');
      formData.append('table', 'insu_counsel_page');
      formData.append('usage', 'image');
      formData.append('user', getMbid());
      formData.append('file', file);

      try {
        const response = await fetch('/api/upload/image', {
          method: 'POST',
          body: formData,
          mode: 'cors',
          credentials: 'include'
        });


        const data = await response.json();
        console.log(data);

        if (data.url) {
          editPage.value.image = data.url;

          // DB 업데이트 (수정 모드일 경우)
          if (editPage.value.idx) {
            await sql_query(`
              UPDATE insu_counsel_page
              SET image='${data.url}'
              WHERE idx=${editPage.value.idx}
            `);
          }
        } else {
          alert("이미지 업로드 실패");
        }
      } catch (err) {
        console.error('업로드 중 오류:', err);
        alert("업로드 중 오류 발생");
      }
    }

    
    async function setOnFileChange(e) {
      const input = e.target;
      const file = input.files ? input.files[0] : null;
      if (!file) return;

      // 1) 로컬 미리보기
      selectedSet.value.cover = URL.createObjectURL(file);

      // 2) 서버 업로드
      const formData = new FormData();
      formData.append('idx', selectedSet.value.idx || '');
      formData.append('table', 'insu_counsel_set');
      formData.append('usage', 'image');
      formData.append('user', getMbid());
      formData.append('file', file);

      try {
        const response = await fetch('/api/upload/image', {
          method: 'POST',
          body: formData,
          mode: 'cors',
          credentials: 'include'
        });
        const data = await response.json();
        console.log(data);

        if (data.url) {
          selectedSet.value.image = data.url;

          // DB 업데이트 (수정 모드일 경우)
          if (selectedSet.value.idx) {
            await sql_query(`
              UPDATE insu_counsel_set
              SET cover='${data.url}'
              WHERE idx=${selectedSet.value.idx}
            `);
          }
        } else {
          alert("이미지 업로드 실패");
        }
      } catch (err) {
        console.error('업로드 중 오류:', err);
        alert("업로드 중 오류 발생");
      }
    }


    async function fetchSetList() {
      const res = await sql_query("SELECT * FROM insu_counsel_set ORDER BY created_at DESC");
      setList.value = res;
    }

    // ---------------------- 페이지 CRUD ----------------------
    async function fetchPageList(counselIdx) {
      const res = await sql_query(`
        SELECT * FROM insu_counsel_page 
        WHERE counsel_idx=${counselIdx} ORDER BY page_no ASC
      `);
      pageList.value = res;
    }

    function newPage() {
      editPage.value = {
        image: "",
        content: "",
        memo: "",
        page_no: pageList.value.length + 1,
        page_type: "content",
      };
      usingDialog.value = "page";
    }

    async function savePage() {
      if (!selectedCounsel.value) return;

      if (editPage.value.idx) {
        await sql_query(`
          UPDATE insu_counsel_page
          SET image='${editPage.value.image}',
              content='${editPage.value.content}',
              memo='${editPage.value.memo}',
              page_no=${editPage.value.page_no},
              page_type='${editPage.value.page_type}',
              question='${editPage.value.question}'
          WHERE idx=${editPage.value.idx}
        `);
        // editPage_options 저장
        if (editPage_options.value && Array.isArray(editPage_options.value)) {
          // 기존 옵션 삭제
          await sql_query(`DELETE FROM insu_counsel_page_option WHERE page_idx=${editPage.value.idx}`);
          // 새로운 옵션 삽입
          for (let i = 0; i < editPage_options.value.length; i++) {
            const option = editPage_options.value[i];
            if (option.option_text && option.option_text.trim() !== '') {
              await sql_query(`
                INSERT INTO insu_counsel_page_option (page_idx, option_no, option_text)
                VALUES (${editPage.value.idx}, ${i + 1}, '${option.option_text}')
              `);
            }
          }
        }
      } else {
        await sql_query(`
          INSERT INTO insu_counsel_page (counsel_idx, image, content, memo, page_no, page_type)
          VALUES (${selectedCounsel.value.idx},
                  '${editPage.value.image}',
                  '${editPage.value.content}',
                  '${editPage.value.memo}',
                   ${editPage.value.page_no},
                  '${editPage.value.page_type}')
        `);
      }
      usingDialog.value = null;
      fetchPageList(selectedCounsel.value.idx);
    }

    async function deletePage() {
      if (!editPage.value.idx) return;
      let ask = confirm("정말 삭제하시겠습니까?");
      if (!ask) return;
      await sql_query(`DELETE FROM insu_counsel_page WHERE idx=${editPage.value.idx}`);
      usingDialog.value = null;
      fetchPageList(selectedCounsel.value.idx);
    }

    function showPicker(bool) {
      adminCounsel_picker_show.value = bool;
    }

    async function onSetSubmit(json) {
      // 저장하고 리로드
      if (!selectedSet.value) return;
      await sql_query(`
        UPDATE insu_counsel_set
        SET counsel_list='${JSON.stringify(json)}'
        WHERE idx=${selectedSet.value.idx}
      `);
      usingDialog.value = null;
      fetchSetList();
    }

    function saveSetInfo() {
      if (!selectedSet.value) return;
      // 저장하고 리로드
      sql_query(`
        UPDATE insu_counsel_set
        SET title='${selectedSet.value.title}',
            description='${selectedSet.value.description}'
        WHERE idx=${selectedSet.value.idx}
      `).then(() => {
        fetchSetList();
      });
      usingDialog.value = null;
    }

    function addOptionsAtPage() {
      if (!editPage_options.value) {
        editPage_options.value = [];
      }
      editPage_options.value.push({ idx: null, page_idx: editPage.value.idx || null, option_no: editPage_options.value.length + 1, option_text: '' });
    }

    // ---------------------- 선택 ----------------------
    function selectCounsel(item) {
      selectedCounsel.value = item;
      fetchPageList(item.idx);
    }

    function selectSet(item) {
      selectedSet.value = { ...item };
      loadCounselSet(selectedSet.value.counsel_list);

      usingDialog.value = 'set';
    }

    // ---------------------- 초기 로딩 ----------------------
    onMounted(() => {
      fetchCounselList();
      fetchSetList();
    });

    return {
      counselList,
      pageList,
      selectedCounsel,
      editCounsel,
      editPage,
      usingDialog,
      fetchCounselList,
      newCounsel,
      saveCounsel,
      deleteCounsel,
      counselOnFileChange,
      selectCounsel,
      newPage,
      savePage,
      deletePage,
      pageOnFileChange,
      categoryList,
      getCategory,
      selChapter,
      setList,
      fetchSetList,
      selectedSet,
      selectSet,
      setCounselList,
      editSet,
      setOnFileChange,
      adminCounsel_picker_show,
      showPicker,
      onSetSubmit,
      saveSetInfo,
      newSet,
      editPage_options,
      selectEditPage,
      addOptionsAtPage,
      deleteCounselSet
    };
  },
};
</script>




<style scoped>
#circleContainer {
  width:100%;
  height:100%;
  margin:0 auto;
}

.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.dialog .cls {
  width:100%;
  height:100%;
  position:absolute;
  left:0;
  top:0;
  z-index: -1;
}

.dialog .paper {
  width: 90%;
  max-width: 600px;
  min-height: 10%;
  height:80%;
  background: var(--color-background);
  border: 2px solid var(--color-background-light);
  border-radius: 16px;
  padding: 16px;
  box-sizing: border-box;
  gap: 24px;
  display: flex;
  flex-direction: column;
}

.dialog .paper .form {
  width:100%;
  flex:1;
  display:flex;
  flex-direction: column;
  gap:12px;
}

.dialog .paper .form > label {
  display: flex;
  flex-direction: column;
  gap:8px;
  color: var(--color-text-primary);
}

.dialog .paper .form > label > img {
  width:100px;
  height:100px;
  object-fit: cover;
  border-radius: 8px;
  background: var(--color-background-light);
}

.dialog .paper .form .options {
  display: flex;
  flex-direction: column;
  gap:8px;
}

.dialog .paper .form > input, .dialog .paper .form > textarea {
  width:100%;
  padding:12px;
  box-sizing: border-box;
  border-radius: 8px;
  border:1px solid var(--color-text-secondary);
  background: var(--color-surface);
  color: var(--color-text-primary);
  font-size: 16px;
}

.dialog .paper .profile-lg {
  width:100%;
  display:flex;
  justify-content: start;
  align-items: center;
  gap:16px;
}

.dialog .paper .profile-lg > label > img {
  width:80px;
  height:80px;
  object-fit: cover;
  border-radius: 8px;
  background: var(--color-background-light);
  cursor: pointer;
}

.dialog .paper .profile-lg > div {
  flex:1;
  display:flex;
  flex-direction: column;
  gap:8px;
}

.dialog .paper .btns {
  width:100%;
  display:flex;
  justify-content: center;
  align-items: center;
  gap:12px;
}

.dialog .paper .btns > button {
  width:100%;
  height:36px;
  flex:1;
  border:none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  color: var(--color-text-primary);
}

.dialog .paper .btns > button.del {
  background: var(--color-special-warning);
}

.dialog .paper .btns > button.save {
  background: var(--color-special-accent);
}

.dialog .paper ul {
  width:100%;
  height: fit-content;
  margin:0;
  padding:0;
  list-style:none;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.dialog .paper ul > li {
  width:100%;
  height:60px;
  box-sizing: border-box;
  border-radius: 4px;
  cursor: pointer;
  color: var(--color-text-primary);
  display:flex;
  justify-content: start;
  align-items: center;
  font-size: 14px;
  gap:12px;
}

.dialog .paper ul > li.add {
  background:var(--color-surface-reverse);
  font-size:var(--font-size-lg);
  align-items: center;
  justify-content: center;
}

.dialog .paper ul > li.active {
  background: var(--color-surface);
}

.dialog .paper ul > li > img {
  width:60px;
  height:60px;
  border-radius: 4px;
  object-fit: cover;
}

.dialog .paper ul > li > .description {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  width:100%;
  height:100%;
  gap:4px;
}

.dialog .paper ul > li > .description > h2 {
  margin:0;
  font-size: 16px;
  color: var(--color-text-primary);
}

.dialog .paper ul > li > .description > span {
  width:100%;
  max-width: 90%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.dialog .paper ul > li > button {
  height:32px;
  border:none;
  border-radius: 8px;
  background: var(--color-special-accent);
  color: var(--color-text-primary);
  cursor: pointer;
  padding:0 12px;
  box-sizing: border-box;
}

.admin-counsel {
  width:100%;
  height: 100%;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  background-color: var(--color-background);
  gap:16px;
}

.admin-counsel > .header { 
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: start;
  align-items: center;
  color: var(--color-text-primary);
  border-bottom: 1px solid var(--color-surface-reverse);
  padding:16px;
  box-sizing: border-box;
}

.chapter {
  width:100%;
  height:40px;
  display:flex;
  justify-content: start;
  align-items: center;
  gap:16px;
  padding:0 16px;
  box-sizing: border-box;
}

.chapter > span {
  padding:8px 16px;
  border-radius: 8px;
  background: var(--color-background-light);
  color: var(--color-text-primary);
  cursor: pointer;
}

.chapter > span.sel {
  background: var(--color-brand);
  color: #000;
}

.content {
  width:100%;
  height:100%;
  flex:1;
  padding:16px;
  box-sizing: border-box;
  display:flex;
  justify-content: start;
  align-items: start;
  gap:16px;
}

.content > .left {
  width:100%;
  flex:1;
  height:100%;
  background:var(--color-background-light);
  border-radius: 12px;
  padding:12px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.content > .left > .header {
  width:100%;
  height:40px;
  display:flex;
  justify-content: space-between;
  align-items: center;
  padding:0 8px;
  box-sizing: border-box;
  border-bottom:1px solid var(--color-text-secondary);
  color: var(--color-text-primary);
}

.content > .left > ul {
  width:100%;
  height: calc(100% - 40px);
  margin:0;
  padding:0;
  list-style:none;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.content > .left > ul > li {
  width:100%;
  height:60px;
  box-sizing: border-box;
  border-radius: 4px;
  cursor: pointer;
  color: var(--color-text-primary);
  display:flex;
  justify-content: start;
  align-items: center;
  font-size: 14px;
  gap:12px;
}

.content > .left > ul > li.active {
  background: var(--color-surface);
}

.content > .left > ul > li > img {
  width:60px;
  height:60px;
  border-radius: 4px;
  object-fit: cover;
}

.content > .left > ul > li > .description {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  width:100%;
  height:100%;
  gap:4px;
}

.content > .left > ul > li > .description > h2 {
  margin:0;
  font-size: 16px;
  color: var(--color-text-primary);
}

.content > .left > ul > li > .description > span {
  width:100%;
  max-width: 90%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.content > .left > ul > li > button {
  height:32px;
  border:none;
  border-radius: 8px;
  background: var(--color-special-accent);
  color: var(--color-text-primary);
  cursor: pointer;
  padding:0 12px;
  box-sizing: border-box;
}

.content > .right {
  flex:3;
  height:100%;
  border:1px solid var(--color-background-light);
  border-radius: 12px;
  padding:12px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: scroll;
}

.content > .right > ul {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* ✅ 항상 2칸 */
  gap: 12px;
  width: 100%;
  height: fit-content;
  margin: 0;
  padding: 0;
  list-style: none;
}

.content > .right > ul > li {
  width:100%;
  height:auto;
  aspect-ratio: 4/3;
  border:1px solid var(--color-text-secondary);
  border-radius: 8px;
  display:flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: var(--color-text-primary);
  cursor: pointer;
  padding:12px;
  box-sizing: border-box;
}

.content > .right > ul > li > img {
  max-width:60%;
  aspect-ratio: 4/3;
  width:100%;
  height:70%;
  object-fit: cover;
  background:var(--color-background-light)
}

.content > .right > ul > li > span {
  width:100%;
  text-align: center;
  margin-top:8px;
  font-size: 14px;
  color: var(--color-text-primary);
}

</style>